import { FullStory } from '@fullstory/browser'

export default function fsCustomEvent (eventName, eventProperties = {}) {
  // @eventName: String 256 chars
  // @eventProperties: Object, max of 8136 bits

  if (process.env.NODE_ENV !== 'production' || !eventName) return

  const properties = {
    name: eventName,
    ...eventProperties
  }

  FullStory('trackEvent', {
    name: eventName,
    properties
  })
}
